<div class="flex justify-between">
	<div class="w-[50%] mr-[16px]">
		<lbca-date-picker
			[label]="labelDateValue"
			(changeValue)="changeDate($event)"
			[value]="valueDate"
			[labeled]="isLabeled"
			[tabeled]="isTabeled"
			[editable]="isEditable"
			[disabled]="isDisabled"
			[require]="isRequired"
			[rules]="rules"
			[disabledDateRules]="disabledDateRules"
			[error]="errorDate"
			[helperText]="helperTextValue"
			(validStatus)="setValid($event)"
			(focusState)="setFocus($event)"
		></lbca-date-picker>
	</div>

	<div class="w-[50%] ml-[16px]">
		<lbca-timepicker
			[label]="labelTimeValue"
			(changeValue)="changeTime($event)"
			(setError)="setErrorFn($event)"
			[value]="formatToTimePiker(valueInput)"
			[require]="isRequired"
			[helperText]="helperTextValue"
			[labeled]="isLabeled"
			[tabeled]="isTabeled"
			[editable]="isEditable"
			[disabled]="isDisabled"
			[error]="errorTime"
			(focusState)="setFocus($event)"
			(validStatus)="setValid($event)"
		></lbca-timepicker>
	</div>
</div>
